import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Checkbox} from "./checkbox";
import {IconFont} from "../../enums/icon-font";

@Component({
  selector: 'brt-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  data?: Checkbox;

  @Input('data') set setInputData(value: Checkbox | undefined) {
    if (typeof value !== 'undefined') {
      this.data = value;
      this.state = this.data.selected;
    }
  }

  @Output('state-changed') stateChanged = new EventEmitter<boolean>();
  @Input('check-icon') checkIcon: IconFont = "check";

  state: boolean = false;

  ngOnInit() {

  }

  onChanged() {
    this.stateChanged.emit(this.state);
  }
}
